export default __webpack_public_path__ + "static/media/santambroeus.90891485.jpeg";